export default "__VITE_ASSET__B_wtY46K__"